import "./TestSampleActivityLogsComponent.scss";
import React, {useCallback, useEffect} from "react";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import commonService from "../../../shared/services/common.service";
import LottieFileGenarationComponent
    from "../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import {ImageConfig} from "../../../constants";
import StatusCardComponent from "../../../shared/components/status-card/statusCardComponent";
import {CommonService} from "../../../shared/services";
import HeadingComponent from "../../../shared/components/heading/headingComponent";
import DetailsDataKeyValueComponent
    from "../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import ActivityLogTimelineComponent
    from "../../../shared/components/activity-log-timeline/ActivityLogTimelineComponent";
import {setCurrentNavParams, setSideMenuView} from "../../../store/actions/header.action";
import {useDispatch} from "react-redux";

interface TestSampleActivityLogsComponentProps {

}

const TestSampleActivityLogsComponent = (props: TestSampleActivityLogsComponentProps) => {
    const params = useParams();
    const [searchParams ] = useSearchParams()
    const testSampleId = params['testSampleID'];
    const testOrderId = params['testOrderId'];

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (searchParams.get('returnModule') === "testOrder" && testOrderId){
            dispatch(setCurrentNavParams("Back", "Test Order", CommonService._routeConfig.TestOrderDetailsRoute(testOrderId)));
            dispatch(setSideMenuView('compact'));
        }
        else{
            dispatch(setCurrentNavParams("Back", "Sample", CommonService._routeConfig.SamplesListRoute()));
            dispatch(setSideMenuView('compact'));
        }
    }, [testOrderId, dispatch, navigate,searchParams]);

    const [sampleDetailsLoading, setSampleDetailsLoading] = React.useState<boolean>(false);
    const [sampleDetailsLoadingFailed, setSampleDetailsLoadingFailed] = React.useState<boolean>(false);
    const [sampleDetailsLoaded, setSampleDetailsLoaded] = React.useState<boolean>(false);

    const [sampleData, setSampleData] = React.useState<any>(null);

    const [sampleLogs, setSampleLogs] = React.useState<any>(null);

    const getSampleDetails = useCallback(() => {
        const payload = {};
        setSampleDetailsLoaded(false);
        setSampleDetailsLoading(true);
        setSampleDetailsLoadingFailed(false);
        commonService._testOrder.getSampleDetails(testOrderId, testSampleId, payload)
            .then((res: any) => {
                setSampleDetailsLoaded(true);
                setSampleDetailsLoading(false);
                setSampleDetailsLoadingFailed(false);
                setSampleData(res.data);
            })
            .catch(
                (err: any) => {
                    setSampleDetailsLoaded(false);
                    setSampleDetailsLoading(false);
                    setSampleDetailsLoadingFailed(true);
                }
            )
    }, [testSampleId, testOrderId]);

    const getsampleLogs = useCallback(() => {
        const payload = {};
        commonService._testOrder.getSampleLogs(testSampleId, payload)
            .then((res: any) => {
                    setSampleLogs(res.data)
                }
            )
            .catch(
                (err: any) => {
                    console.log(err)
                })
    }, [testSampleId])

    useEffect(() => {
        if (testSampleId && testOrderId) {
            getSampleDetails();
            getsampleLogs();
        }

    }, [testSampleId, testOrderId, getSampleDetails, getsampleLogs])

    return (
        <div className={'test-sample-activity-logs-component details-screen screen'}>
            {
                sampleDetailsLoading && <div className="h-v-center">
                    <LottieFileGenarationComponent
                        loop={true}
                        autoplay={true}
                        animationData={ImageConfig.LoadingLottieFile}/>
                </div>
            }
            {
                sampleDetailsLoadingFailed && <>
                    <StatusCardComponent title={"TestOrder details failed to load"}/>
                </>
            }
            {
                sampleDetailsLoaded && <>
                    <div className={'details-module-title'}>Activity Log</div>
                    <div className="basic-details-wrapper">
                        <div className="basic-details-wrapper">
                            <div className="details-screen-header-status-section mrg-bottom-20">
                                <div className="details-screen-header">
                                    <HeadingComponent
                                        title={`${CommonService.capitalizeFirstLetterOfEachWord(sampleData?.testDetails?.name)}`}
                                        statusLabel={sampleData?.status}
                                    />
                                </div>
                                <div className="details-screen-sub-header">
                                    <DetailsDataKeyValueComponent
                                        title={"Barcode (Accession ID):"}
                                        isHorizontal={true}> {CommonService.capitalizeFirstLetterOfEachWord(sampleData?.barcode)} </DetailsDataKeyValueComponent>

                                    <DetailsDataKeyValueComponent
                                        title={"Date of Collection:"}
                                        isHorizontal={true}>
                                        <>
                                            {commonService.formatDate(sampleData?.createdAt)}
                                        </>
                                    </DetailsDataKeyValueComponent>
                                    <DetailsDataKeyValueComponent
                                        title={"Time of Collection:"}
                                        isHorizontal={true}> {commonService.formatTime(sampleData?.createdAt)} </DetailsDataKeyValueComponent>
                                </div>
                            </div>
                            <div className="details-screen-body">
                                <ActivityLogTimelineComponent logsData={sampleLogs}/>
                            </div>
                        </div>
                    </div>
                </>
            }
        </div>
    );
};

export default TestSampleActivityLogsComponent;
